import Component from 'gia/Component'
import _each from 'lodash.foreach'
import gsap from 'gsap'
import stage from '../components/stage'
import {
  ScrollTrigger
} from "gsap/ScrollTrigger.js";
gsap.registerPlugin(ScrollTrigger);
import Observer from '../components/observer';

class Loader extends Component {

  constructor(element) {

    super(element)

    this.body = $('body')
    this.html = $('html')

    this.element = element
    this.el = $(element)
    this.index = 0
    this.current = 0

    this.decos = []
    this.imgs = []


    this.ref = {
      deco: [],
      message: null,
      k: null,
      bg: null,
      overlay: null

    }

  }

  mount() {

    const once = document.body.classList.contains('is-home')
    document.body.classList.remove('home-is-loaded')
    lenis.stop()

   

    const image = '/images/silkwave.jpg';
    this.load(image).then(() => {
      this.element.classList.add('loaded')
      document.body.classList.add('intro-loaded')

      this.delay()
    });

  

  }

  delay() {
    this.delayedCall = gsap.delayedCall(1, () => {
      this.start()
    });
  }

  start() {
    document.body.classList.add('is-started')
    lenis.start()

   

     this.delayedCall = gsap.delayedCall(1, () => {
          this.element.classList.add('is-loaded')
            document.body.classList.add('home-is-loaded')
           $('body').addClass(`has-nav`)
     });


    // this.anim1 = gsap.to(this.ref.k, {
    //   opacity: 0,
    //   scrollTrigger: {
    //     trigger: this.ref.cover,
    //     start: "top bottom",
    //     end: "top top",
    //     scrub: .25
    //   }
    // })


    // _each(this.ref.deco, (item, i) => {

    //   const anim = gsap.to(item, {
    //     yPercent: -item.dataset.offset,
    //     scrollTrigger: {
    //       trigger: this.ref.cover,
    //       start: "top bottom",
    //       end: "top top",
    //       scrub: .25
    //     }
    //   })
    //   this.decos.push(anim)
    // })





  }


  load(src) {
    return new Promise((resolve, reject) => {
      const image = new Image();
      image.addEventListener('load', resolve);
      image.addEventListener('error', reject);
      image.src = src;
    });
  }



  resize() {

  }

  unmount() {

    this.observer.disconnect()
    this.anim1.kill()

    _each(this.decos, (item, index) => {
      item.kill();
    })



  }


}

module.exports = Loader